import * as React from "react";
import { Row, Col, Form, notification, Select, Table, Icon, Spin } from "antd";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { useContext, useState, useEffect, Fragment } from "react";
import { FormComponentProps } from "antd/lib/form";
import { Columns } from "src/pages/step-flow/steps/certificates/Columns";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import PbrCertificateUploader, { IFileToUpload } from "src/components/common/PbrCertificateUploader/PbrCertificateUploader";
import { IDocument } from "src/services/interfaces/IDocument";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { ServiceContext } from "src/services/provider/Service.provider";

import "./certificates.scss";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import { DocumentCategoryLabel, DocumentCategoryEnum } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';

interface ICertificate {
  title: string;
}

function Certificates(props: FormComponentProps & IVendaProps) {
  const { documentService, tradeService } = useContext(ServiceContext);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [certificate, setCertificate] = useState<any>(null);
  const [error] = useState<string | null>(null);
  const [selectedCertificate, setSelectedCertificate] = useState("");
  const [values, setValues] = useState<ICertificate[]>([]);
  const [data, setData] = useState([]);
  const [sendCertificateSuccess, setSendCertificateSuccess] = useState(false);
  const [deleteCertificateSuccess, setDeleteCertificateSuccess] = useState(false);
  const [downloadCertificateSuccess, setDownloadCertificateSuccess] = useState(false);
  const [legalCertificates, setlegalCertificates] = useState<DocumentCategoryEnum[]>([]);

  useEffect(() => {
    documentService.getDocumentCategory()
      .then(resp => {
        setlegalCertificates(resp)
      })
      .catch(ex => {
        ShowNotification.Error("Ocorreu um erro", "Ocorreu um erro ao carregar Categorias")
      })
  }, []);


  useEffect(() => {
    fetch();
  }, [sendCertificateSuccess, deleteCertificateSuccess, downloadCertificateSuccess]);

  async function fetch(params = {}) {
    setLoading(true);

    try {
      const trades = await documentService.getLegalCertificatesByTradeId(props.trade.id);
      const models = trades.map(
        t =>
          ({
            id: t.id,
            category: t.category,
            fileName: t.fileName,
            path: t.path,
            description: DocumentCategoryLabel.get(DocumentCategoryEnum[t.category]),
            storageType: t.storageType,
            uploadDate: t.uploadDate
          } as IDocument)
      );

      setData(models);
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Falha na consulta",
        description: "Ocorreu um erro durante a consulta. Tente novamente."
      });
    } finally {
      setLoading(false);
    }
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setSendCertificateSuccess(false);
    tradeService
      .putUploadLegalCertificates({
        id: 0,
        category: selectedCertificate,
        file: certificate.file,
        description: values[0].title,
        storageType: "S3",
        tradeId: props.trade.id,
        fileName: certificate.name
      })
      .then(response => {
        setSelectedCertificate("");
        setValue("");
        setValues([]);
        setCertificate(null);
        setSendCertificateSuccess(true);
        ShowNotification.Success("Sucesso!", response.message)
      })
      .catch(ex => {
        ShowNotification.Error("Ocorreu um erro", ex?.response?.data?.message)
      })
      .finally(() => setLoading(false));
  }

  const onClickAddList = (title: string): void => {
    const newList: ICertificate[] = [{ title }];
    setValues(newList);
  };

  function handleChange(fileToUpload: IFileToUpload) {
    fileToUpload.type = "certificate";
    setCertificate(fileToUpload);
  }

  const handleAdvance = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSendCertificateSuccess(false);
    tradeService
      .putSendLegalCertificatesToLawyer({
        id: props.trade.id
      })
      .then(response => {
        ShowNotification.Success("Sucesso!", response.message)
        props.onChangePhase(TradePhaseEnum.DocumentValidation);
      })
      .catch(ex => {
        ShowNotification.Error("Ocorreu um erro", ex?.response?.data?.message)
      })
      .finally(() => setLoading(false));
  };

  const Option = Select.Option;

  return (
    <div className="documents steps-container">
      <h1>Envio de certidões</h1>
      <Spin spinning={loading} delay={500}>
        <Form onSubmit={handleSubmit}>
          {data.length > 0 && (
            <Row type="flex" justify="center" align="middle" style={{ marginTop: "100px" }}>
              <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: "center" }}>
                <Table
                  scroll={{ x: 750 }}
                  columns={Columns(documentService, setLoading, setDeleteCertificateSuccess, setDownloadCertificateSuccess, loading)}
                  rowKey={record => record.id}
                  dataSource={data}
                  loading={loading}
                />
              </Col>
            </Row>
          )}
          <PbrSeparator />
          <Row type="flex" justify="center" align="middle" className="document-row" gutter={16}>
            <Col xs={24} lg={16} style={{ minHeight: "97px" }}>
              <PbrSelect
                name="Certidão"
                size="large"
                showSearch
                value={selectedCertificate}
                onChange={e => {
                  setSelectedCertificate(e.toString());
                  setValue("");
                  setValues([]);
                  setCertificate(null);
                }}
                placeholder="Selecione o tipo de certidão a ser adicionada"
                rules={[
                  {
                    required: true,
                    message: "Selecione uma certidão"
                  }
                ]}
              >
                {legalCertificates.map((e, i) => (
                  <Option key={i.toString()} value={e}>{`${DocumentCategoryLabel.get(e)}`}</Option>
                ))}
              </PbrSelect>
            </Col>
            <Col xs={24} lg={8} style={{ minHeight: "97px", paddingBottom: "57px" }}>
              <StandardButton disabled={selectedCertificate === "Outra" || !selectedCertificate} onClick={() => onClickAddList(selectedCertificate)}>
                Adicionar
              </StandardButton>
            </Col>
            {selectedCertificate === "Outra" && (
              <Col
                xs={24}
                lg={24}
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                  paddingBottom: "40px",
                  color: "#32bf72"
                }}
              >
                <Icon type="arrow-down" />
              </Col>
            )}
            {selectedCertificate === "Outra" && (
              <Col xs={24} lg={16} style={{ minHeight: "67px" }}>
                <PbrInput
                  name="select_certidoes"
                  error={!!error}
                  id="certificateTitle"
                  value={value}
                  onChange={e => {
                    setValue(e.target.value);
                    setValues([]);
                    setCertificate(null);
                  }}
                  placeholder="Digite o nome do tipo de certidão a ser adicionada"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    border: "2px",
                    height: "48px"
                  }}
                />
              </Col>
            )}
            {selectedCertificate === "Outra" && (
              <Col xs={24} lg={8} style={{ minHeight: "67px" }}>
                <StandardButton disabled={value.length < 5} onClick={() => onClickAddList(value)}>
                  Adicionar Tipo de Certidão
                </StandardButton>
              </Col>
            )}
            {values.map((c: ICertificate, index: number) => (
              <Fragment key={index}>
                <Col
                  xs={24}
                  lg={24}
                  style={{
                    minHeight: "67px",
                    paddingBottom: "50px"
                  }}
                >
                  <PbrCertificateUploader
                    btnText={`Subir Arquivo`}
                    title={`Envie o arquivo da(o) ${c.title}.`}
                    onChangeBase64={val => handleChange(val)}
                    style={{ textAlign: "center" }}
                  />
                </Col>
                {certificate && (
                  <Col xs={{ span: 24, offset: 17 }} lg={{ span: 24, offset: 17 }}>
                    <StandardButton disabled={!certificate} loading={loading} htmlType="submit" style={{ textAlign: "center" }}>
                      Enviar Arquivo
                    </StandardButton>
                  </Col>
                )}
              </Fragment>
            ))}
          </Row>
          <PbrSeparator />
          <Row type="flex" justify="center" align="middle" style={{ marginBottom: "50px" }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: "center" }}>
              <StandardButton loading={loading} style={{ margin: "auto" }} onClick={e => handleAdvance(e)}>
                Avançar
              </StandardButton>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}

export default Form.create()(Certificates);



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/certificates/Certificates.tsx